import { render, staticRenderFns } from "./news-view-toolbar.vue?vue&type=template&id=45c3dddd&"
import script from "./news-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./news-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports